"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _curryRight = _interopRequireDefault(require("lodash/fp/curryRight"));
var _FormContext = require("../Form/FormContext");
var _connectForm = _interopRequireDefault(require("../Form/connectForm"));
var _FormGroup = require("../FormGroup");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FormFieldWrapper = function FormFieldWrapper(_ref) {
  var alignment = _ref.alignment,
    className = _ref.className,
    children = _ref.children,
    withoutLayout = _ref.withoutLayout;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "form-field",
    className: (0, _classnames["default"])('form-field', {
      'grid-item span-sm-12 span-md-4': alignment === _FormContext.HORIZONTAL && !withoutLayout
    }, className)
  }, children);
};
var FormFieldWrapperContainer = (0, _compose["default"])((0, _curryRight["default"])(_connectForm["default"])(function (_ref2) {
  var customizeLayout = _ref2.customizeLayout,
    alignment = _ref2.form.alignment;
  return _objectSpread({
    alignment: alignment
  }, customizeLayout ? {
    withoutLayout: true
  } : {});
}), _FormGroup.connectFormGroup, _react.memo)(FormFieldWrapper);
var _default = exports["default"] = FormFieldWrapperContainer;